module.exports = __webpack_public_path__ + "img/hire-a-helper.04f89d8c.svg";